<!--
 * @Author: git config zhang && 10899060+inheaven98@user.noreply.gitee.com
 * @Date: 2024-03-15 16:13:46
 * @LastEditors: inHeaven98 10899060+inheaven98@user.noreply.gitee.com
 * @LastEditTime: 2024-11-04 14:49:35
 * @FilePath: \cei-saas-platform\src\layout\components\Sidebar\SidebarItem.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
	<div v-if="!item.hidden">
		<template
			v-if="
				hasOneShowingChild(item.children, item) &&
				(!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
				!item.alwaysShow
			"
		>
			<app-link v-if="onlyOneChild.meta && onlyOneChild.meta.isShow===1" :to="resolvePath(onlyOneChild.path)">
				<el-menu-item
					:index="resolvePath(onlyOneChild.path)"
					:class="{ 'submenu-title-noDropdown': !isNest }"
				>
					<item
						:icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
						:title="onlyOneChild.meta.title"
						:isDot="onlyOneChild.meta.isDot"
						:isDotC = "onlyOneChild.meta.isDotC"
						
					/>
				</el-menu-item>
			</app-link>
		</template>

		<el-submenu
			v-else
			ref="subMenu"
			:index="resolvePath(item.path)"
			popper-append-to-body
		>
			<template slot="title">
				<item
					v-if="item.meta"
					:icon="item.meta && item.meta.icon"
					:title="item.meta.title"
					:isDotP="item.meta.isDotP"
					
				/>
			</template>
			<sidebar-item
				v-for="child in item.children"
				:key="child.path"
				:is-nest="true"
				:item="child"
				:base-path="resolvePath(child.path)"
				class="nest-menu"
				
			/>
		</el-submenu>
	</div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
	name: 'SidebarItem',
	components: { Item, AppLink },
	mixins: [FixiOSBug],
	props: {
		// route object
		item: {
			type: Object,
			required: true
		},
		isNest: {
			type: Boolean,
			default: false
		},
		basePath: {
			type: String,
			default: ''
		}
	},
	data() {
		// To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
		// TODO: refactor with render function
		this.onlyOneChild = null
		return {
		}
	},
	mounted() {},
	methods: {
		hasOneShowingChild(children = [], parent) {
			// 合同管理
			if (parent.name == 'contractManagement') {
				const isDot = this.$store.state.recordsStatus.recordsStatus
				parent.meta.isDotP = isDot
				parent.meta.isShow = 1
			}
			
			const showingChildren = children.filter((item) => {
				if (item.hidden) {
					return false
				} else {
					// Temp set(will be used if only has one showing child)
					item.meta.isShow = 1
					this.onlyOneChild = item
					 
					if (process.env.NODE_ENV === 'development' && item.name == 'serverList') {
						item.meta.isShow = 0
					} 
					if (process.env.NODE_ENV === 'production' && item.name == 'serverList') {
						item.meta.isShow = 1
					}
					// 获取智能台账路径的未读状态
					if (item.name == 'intelligentLedger') {
						const isDot = this.$store.state.recordsStatus.recordsStatus
						item.meta.isDot = isDot
					}
					// 获取聊天路径的未读状态
					if (item.name == 'homeEditor') {
						const isDot = this.$store.state.readChatStatus.readChatStatus
						item.meta.isDotC = isDot
					}
					return true
				}
			})

			// When there is only one child router, the child router is displayed by default
			if (showingChildren.length === 1) {
				// console.log('1111111111', showingChildren)

				return true
			}

			// Show parent if there are no child router to display
			if (showingChildren.length === 0) {
				this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
				return true
			}

			return false
		},
		resolvePath(routePath) {
			if (isExternal(routePath)) {
				return routePath
			}
			if (isExternal(this.basePath)) {
				return this.basePath
			}
			return path.resolve(this.basePath, routePath)
		}
	}
}
</script>
